import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Button, Grid, Typography , Menu , MenuItem , TextField , Box } from "@mui/material";
import {ListAlt ,SignalCellularAlt , AirportShuttle} from "@mui/icons-material";
import { ContentCopyOutlined, TableChartOutlined, DescriptionOutlined, PictureAsPdfOutlined, FileDownloadOutlined } from "@mui/icons-material";
import { DataGrid  } from "@mui/x-data-grid";
import "jspdf-autotable";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { useFormik, useField } from "formik";
import * as yup from "yup";
import _ from "lodash";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { CUSTOM_CONSTANTS } from "Constants/index";

//Services
import TriplistApi from "Services/Triplist";
import Passengerhistorydetails from "Pages/Modals/Passengerhistory/Moredetails";

const DriverReport = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [row, setRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);  
  const location = useLocation();
  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [moredetailsmodel, setmoredetailsModal] = useState(false);
  const Tripstatus = ["CANCELLED", "COMPLETED", "SCHEDULED"];
  const Paymentmethod = ["CASH", "CARD", "CORPORATE"];
  const [filtervalues , setFiltervalues] = useState({});
  const [requestId, setrequestId] = useState("");
   const [metrics,setmetrics] = useState({});
  const openaction = Boolean(anchorEl);
  const { driverRideId, driverId } = location.state || {};

  // Get Driver list api

  const gettriplists = useCallback(() => {
   // console.log('driverRideId--->',driverRideId);
   // console.log("driverId--->",driverId);
   // console.log('filtervalues-->',filtervalues);
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
      //  console.log('rides of driver--->',res?.data);
        setRow(res?.data?.data?.data);
        setmetrics({
          totalRidesCount: res?.data?.data.totalRecords,
          cancelledRides: res?.data?.data.cancelledRides,
          totalRevenue: res?.data?.data.totalRevenue,
        });
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    TriplistApi.getridesofdriver({ page, limit: pageSize , driver_ride_id:driverRideId, driver_id:driverId , filtervalues })
      .then(onSuccess, onFailure);
  }, [page, pageSize , filtervalues]);

  const getalltriplists = useCallback(() => {
  //  dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
    //  dispatch(hideLoader());
      if (res?.data?.status === true) {   
      //  console.log('rides of driver--->',res?.data);
        setbulkrow(res?.data?.data?.data);
      } else {
        setbulkrow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    TriplistApi.getridesofdriver({ page:1, limit: "unlimited" , driver_ride_id:driverRideId, driver_id:driverId , filtervalues:"" })
      .then(onSuccess, onFailure);
  }, []);

  useEffect(() => {
    gettriplists();
    getalltriplists();
  }, [gettriplists]);

  const handleDownloadAll = () => {
    const csv = Papa.unparse(bulkformatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "All reportList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }; 

  const handleview = (event, rowData) => {
   // console.log('rowData-->',rowData)
    setrequestId(rowData?._id);
    setmoredetailsModal(true);
  };

  const handleClosemoredetailsModal = () => {
    setmoredetailsModal(false);
    gettriplists();
  };

  const handlePageChange = (newPage) => {
  //  console.log('newPage-->',newPage);
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A"; // Handle undefined or null values
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

  const ensureRowId = (data, index) => {
    return (
      data?.id ||
      data?._id ||
      data?.bookingId ||
      data?.booking_id ||
      data?.tripId ||
      data?.trip_id ||
      data?.provider_id ||
      `${page}-${index}`
    );
  };
 
  const handleCopy = () => {
    // Define column widths
    const columnWidths = [5, 15, 25, 15, 15, 15, 15]; // Adjust widths as needed
  
    // Helper function to pad text to the desired width
    const padText = (text, width) => {
      return (text ?? "").toString().padEnd(width, " ");
    };
    // Create table header
    const header = [
      padText("S.NO", columnWidths[0]),
      padText("Booking ID", columnWidths[1]),
      padText("Picked Up", columnWidths[2]),
      padText("Stop 1", columnWidths[3]),
      padText("Stop 2", columnWidths[4]),
      padText("Dropped", columnWidths[5]),
      padText("Dated on", columnWidths[6]),
      padText("Status", columnWidths[7]),
      padText("Payment", columnWidths[8]),
      padText("Earnings", columnWidths[9]),
      padText("Total", columnWidths[10])
    ].join("");
  
    // Create table rows
    const rows = dataRows
      .map((row) =>
        [
          padText(row.sno, columnWidths[0]),
          padText(row.bookingid, columnWidths[1]),
          padText(row.pickupaddress, columnWidths[2]),
          padText(row.stop1address, columnWidths[3]),
          padText(row.stop2address, columnWidths[4]),
          padText(row.droppedaddress, columnWidths[5]),
          padText(row.startedat, columnWidths[6]),
          padText(row.status, columnWidths[7]),
          padText(row.payment,columnWidths[8]),
          padText("R "+row.earnings, columnWidths[9]),
          padText("R "+row.total, columnWidths[10])
        ].join("")
      )
      .join("\n");
  
    // Combine header and rows
    const formattedContent = [header, rows].join("\n");
  
    // Copy to clipboard
    navigator.clipboard.writeText(formattedContent).then(() => {
      alert("Table copied to clipboard!");
    });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Services");
    XLSX.writeFile(workbook, "Driver_info.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Driver_info.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((row) => [
      row.sno,row.bookingid,row.pickupaddress,
     row.stop1address,row.stop2address,row.droppedaddress,row.startedat,row.status,row.payment,"R "+row.earnings,"R "+row.total,
]);
    doc.autoTable({
head: [["S.NO","Booking ID","Picked Up","Stop 1","Stop 2","Dropped","Dated on","Status","Payment Mode","Earnings","Total"]],
body: tableData,
    });
    doc.save("Driver_info.pdf");
  };


  const dataRows = _.map(row || [], (data, index) => ({
    id: ensureRowId(data, index),
    sno: calculateSno(page, pageSize, index),
    bookingid: data?.bookingId,
    pickupaddress:data?.pickupAddress,
    stop1address:data?.stop1_address||"--",
    stop2address:data?.stop2_address||"--",
    droppedaddress:data?.dropAddress,
    startedat:data?.acceptedAt ? formatDate(data?.acceptedAt):"",
    status:data?.tripStatus,
    statusbackground:data?.tripStatus == "COMPLETED" ? "#00c292" : "#f8312fd6",
    payment:data?.paymentMode, 
    earnings:data?.driverEarnings ? (data?.driverEarnings?.earnings ?? 0) :0,
    total:data?.estimatedFare||0,
    row: data,
  }));

  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex: 1,
      minWidth: 60, 
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "bookingid",
      headerName: "Booking ID",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.bookingid}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "pickupaddress",
      headerName: "Picked up",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.pickupaddress}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "stop1address",
      headerName: "Stop 1",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2"
              >{params?.row?.stop1address}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "stop2address",
      headerName: "Stop 2",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2" 
              >{params?.row?.stop2address}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "droppedaddress",
      headerName: "Dropped",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.droppedaddress}</Typography>
            </div>
          </>
        );
      },
    },
    {
        field: "actions",
        headerName: "Request Details",
        minWidth: 150, 
        resizable: true, 
        sortable: false,
        disableColumnMenu: true,
        renderCell: (params) => {
          const rowData = params?.row?.row;
          return (
            <>
        <div className={classes.iconsWrapper}>
        <Button
          id="basic-button"
          onClick={(e) => handleview(e, rowData)}
        >
          View
        </Button>
            </div>
            </>
          );
        },
    }, 
    {
      field: "startedat",
      headerName: "Dated on",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.startedat}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2" className={classes.status}
              sx={{ background: params?.row?.statusbackground }}
              >{params?.row?.status}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "payment",
      headerName: "Payment Mode",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.payment}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "earnings",
      headerName: "Earnings",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{CUSTOM_CONSTANTS.BASE_CURRENCY} {params?.row?.earnings.toFixed(2)}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "total",
      headerName: "Total",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{CUSTOM_CONSTANTS.BASE_CURRENCY} {params?.row?.total.toFixed(2)}</Typography>
            </div>
          </>
        );
      },
    },
  ];

  const formatteddatas = dataRows.map((row) => ({
    "S.NO": row.sno,
    "Booking ID":row.bookingid,
    "Picked Up":row.pickupaddress,
    "Stop 1": row.stop1address,
    "Stop 2": row.stop2address,
    "Dropped":row.droppedaddress,
    "Dated on":row.startedat,
    "Status":row.status,
    "Payment mode":row.payment,
    "Earnings":"R "+row.earnings,
    "Total":"R "+row.total
  }));

  const bulkdataRows = _.map(
    _.orderBy(bulkrow || [], ['createdAt'], ['asc']),
    (data, index) => ({
  sno: calculateSno(page, pageSize, index),
    bookingid: data?.bookingId,
    pickupaddress:data?.pickupAddress,
    stop1address:data?.stop1_address||"--",
    stop2address:data?.stop2_address||"--",
    droppedaddress:data?.dropAddress,
    startedat:data?.acceptedAt ? formatDate(data?.acceptedAt):"",
    status:data?.tripStatus,
    statusbackground:data?.tripStatus == "COMPLETED" ? "#00c292" : "#f8312fd6",
    payment:data?.paymentMode, 
    earnings:data?.driverEarnings ? (data?.driverEarnings?.earnings ?? 0) :0,
    total:data?.estimatedFare||0,
    row: data,
  }));  
  
  const bulkformatteddatas = bulkdataRows.map((row) => ({
   "S.NO": row.sno,
    "Booking ID":row.bookingid,
    "Picked Up":row.pickupaddress,
    "Stop 1": row.stop1address,
    "Stop 2": row.stop2address,
    "Dropped":row.droppedaddress,
    "Dated on":row.startedat,
    "Status":row.status,
    "Payment mode":row.payment,
    "Earnings":"R "+row.earnings,
    "Total":"R "+row.total
  })); 

    // handle dates
  
  const handlefromdate = (newValue) => {
    if (newValue === null || newValue === "") {
      formik.setFieldValue("fromdate", newValue);
    } else {
      const selectedDate =
        newValue instanceof Date ? newValue : new Date(newValue);
      const parsedDate = moment(selectedDate);
      const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
      formik.setFieldValue("fromdate", formattedDate);
    }
  };
  
  const handletodate = (newValue) => {
    if (newValue === null || newValue === "") {
      formik.setFieldValue("todate", newValue);
    } else {
      const selectedDate =
        newValue instanceof Date ? newValue : new Date(newValue);
      const parsedDate = moment(selectedDate);
      const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
      formik.setFieldValue("todate", formattedDate);
    }
  };
  
    // filter form 
  
    function convertToISO(inputDate) {
      if (!inputDate) {
        return "--"; // Handle null or undefined input
      }
    
      // Parse the input date string
      const date = new Date(inputDate);
    
      if (isNaN(date.getTime())) {
        return "--"; // Handle invalid date formats
      }
    
      // Convert to ISO string and replace "Z" with "+00:00" for UTC offset
      const isoString = date.toISOString().replace("Z", "+00:00");
      return isoString;
    }
    
  
  const handlefiltertriplist = (formValues) => {
     
    formValues.fromdate = convertToISO(formValues.fromdate);
    formValues.todate = convertToISO(formValues.todate);
   // console.log('formValues-->',formValues);
   // dispatch(showLoader("Loading please wait..."));
    setFiltervalues(formValues);
    };

   const formik = useFormik({
      initialValues: {
        tripStatus: "",
        paymentMode: "",
        fromdate: "",
        todate: "",
      },
      validationSchema: yup.object({
        fromdate: yup.string().required("Status is required").nullable(),
        todate: yup.string().required("Service is required").nullable(),
      }),
      enableReinitialize: true,
      onSubmit: async (values) => {
        handlefiltertriplist(values); // Ensure this processes `values` correctly
      },
    });

  return (  
    <>

<div className={classes.pages}>
<Grid container className={classes.root}>

<Grid container className={classes.metricboxes}>

<Grid item xs={4} className={classes.metricbox} >
<Box sx={{ background: '#fb9678' }}>
<Typography variant="h2">{metrics.totalRidesCount}</Typography>
<Typography variant="body2">TOTAL NO OF RIDES</Typography>
<ListAlt/>
</Box>
</Grid>
<Grid item xs={4} className={classes.metricbox} >
<Box sx={{ background: '#00c292' }}>
<Typography variant="h2">{CUSTOM_CONSTANTS.BASE_CURRENCY}  {metrics.totalRevenue}</Typography>
<Typography variant="body2">REVENUE</Typography>
<SignalCellularAlt/>
</Box>
</Grid>
<Grid item xs={4} className={classes.metricbox} >
<Box sx={{ background: '#ab8ce4' }}>
<Typography variant="h2">{metrics.cancelledRides}</Typography>
<Typography variant="body2">CANCELLED RIDES</Typography>
<AirportShuttle/>
</Box>
</Grid>

</Grid>

<Grid container className={classes.utilities}>

<Grid item xs={2} md={2} lg={2} xl={2} className={classes.filters}>
<TextField
  name="tripStatus"
  id="tripStatus"
  select
  label="All status"
  value={formik?.values?.tripStatus || ""}
  onChange={formik?.handleChange}
  error={
    formik?.errors?.tripStatus &&
    formik?.touched?.tripStatus
  }
  helperText={
    formik?.errors?.tripStatus &&
    formik?.touched?.tripStatus &&
    formik?.errors?.tripStatus
  }
  fullWidth
  variant="outlined"
  size="small"
>
<MenuItem key="All status" value="">
    All Status
  </MenuItem> 
{Tripstatus.map((status) => (
  <MenuItem key={status} value={status}>
    {status}
  </MenuItem>
))}
</TextField>
</Grid>
<Grid item xs={2} md={2} lg={2} xl={2} className={classes.filters}>
<TextField
  name="paymentMode"
  id="paymentMode"
  select
  label="All Payment"
  value={formik?.values?.paymentMode || ""}
  onChange={formik?.handleChange}
  error={
    formik?.errors?.paymentMode &&
    formik?.touched?.paymentMode
  }
  helperText={
    formik?.errors?.paymentMode &&
    formik?.touched?.paymentMode &&
    formik?.errors?.paymentMode
  }
  fullWidth
  variant="outlined"
  size="small"
>
<MenuItem key="All payment" value="">
    All Payment
  </MenuItem>
{Paymentmethod.map((booking) => (
  <MenuItem key={booking} value={booking}>
    {booking}
  </MenuItem>
))}
</TextField>
</Grid>
<Grid item xs={3} md={3} lg={3} xl={3} className={classes.filters}>
  <div className={classes.datePickerStyle}>
  <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
  label="From Date"
  value={formik?.values?.fromdate || ""}
  size="small"
  onChange={(newValue) => {
  handlefromdate(newValue);
  }}
  renderInput={(params) => (
  <TextField
    {...params}
    error={
      formik?.errors?.fromdate &&
      formik?.touched?.fromdate
    }
    helperText={
      formik?.errors?.fromdate &&
      formik?.touched?.fromdate &&
      formik?.errors?.fromdate
    }
  />
  )}
  />
  </LocalizationProvider>
  </div>
</Grid>
<Grid item xs={3} md={3} lg={3} xl={3} className={classes.filters}>
<div className={classes.datePickerStyle}>
  <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
  label="To Date"
  value={formik?.values?.todate || ""}
  size="small"
  onChange={(newValue) => {
  handletodate(newValue);
  }}
  renderInput={(params) => (
  <TextField
    {...params}
    error={
      formik?.errors?.todate &&
      formik?.touched?.todate
    }
    helperText={
      formik?.errors?.todate &&
      formik?.touched?.todate &&
      formik?.errors?.todate
    }
  />
  )}
  />
  </LocalizationProvider>
  </div>
</Grid>
<Grid item xs={2} md={2} lg={2} xl={2} className={classes.Endbtn}>
    <Button variant="contained" onClick={formik?.handleSubmit}>
      Filter
    </Button>
</Grid>

</Grid>

<Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
    <Button variant="contained" startIcon={<ContentCopyOutlined />} onClick={handleCopy}>
      COPY
    </Button>
  </Grid>
  <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
    <Button variant="contained" startIcon={<TableChartOutlined />} onClick={handleDownloadExcel}>
      EXCEL
    </Button>
  </Grid>
  <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
    <Button variant="contained" startIcon={<DescriptionOutlined />} onClick={handleDownloadCSV}>
      CSV
    </Button>
  </Grid>
  <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
    <Button variant="contained" startIcon={<PictureAsPdfOutlined />} onClick={handleDownloadPDF}>
      PDF
    </Button>
  </Grid>
 <Grid item xs={2} md={2} lg={2} xl={2} className={classes.funBtn}>
      <Button variant="contained" startIcon={<FileDownloadOutlined />} onClick={handleDownloadAll}>
      Download ALL
      </Button>
      </Grid>  
<Grid item xs={12}>
    <section className={classes.dataGridTable}>
      <DataGrid
       className={classes.tripgridtable}
        getRowId={(gridRow, index) =>
          gridRow?.id ||
          gridRow?.row?.id ||
          gridRow?.row?._id ||
          gridRow?.row?.booking_id ||
          gridRow?.row?.bookingId ||
          gridRow?.row?.trip_id ||
          gridRow?.row?.tripId ||
          `fallback-${index}`
        }
        rows={dataRows}
        columns={columns}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => {
        //  console.log("newPageSize--->",newPageSize);
          setPageSize(newPageSize);
          setPage(1);
        }}
        onPageChange={(newPage) => handlePageChange(newPage)}
        rowsPerPageOptions={[5, 10, 25, 50]}
        pagination
        autoHeight={true}
        disableSelectionOnClick
        scrollbarSize={4}
        rowHeight={100}
        style={{ padding: "10px", borderRadius: "0px" }}
        paginationMode="server"
        rowCount={totalPages}
      />
    </section>
</Grid>

</Grid>
<Passengerhistorydetails
        openDialog={moredetailsmodel}
        id={requestId}
        handleClose={handleClosemoredetailsModal}
></Passengerhistorydetails>
</div>

    </>
  );
};

export default DriverReport;
